
export default {
  name: 'ImgZoom',
  props: {
    src: {
      type: String,
      required: true,
    },
    bigSrc: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: 'auto',
    },
    height: {
      type: [String, Number],
      default: 'auto',
    },
    bigWidth: {
      type: [String, Number],
      default: 256,
    },
    bigHeight: {
      type: [String, Number],
      default: 256,
    },
    maskWidth: {
      type: [String, Number],
      default: 0,
    },
    maskHeight: {
      type: [String, Number],
      default: 0,
    },
    smallImgClass: {
      type: String,
    },
    bigImgClass: {
      type: String,
    },
    maskClass: {
      type: String,
    },
    internal: {
      type: Boolean,
      default: false,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      bigImg: {},
      isActive: false,
      actualBigHeight: 0,
      actualBigWidth: 0,
    };
  },
  computed: {
    isZoomOn() {
      return this.enabled && this.isActive && this.bigSrc && this.bigHeight && this.bigWidth;
    },
    imglisteners() {
      const listeners = {};
      if (this.$listeners.error) {
        listeners.error = this.$listeners.error;
      }
      if (this.$listeners.load) {
        listeners.load = this.$listeners.load;
      }
      if (this.$listeners.loadstart) {
        listeners.loadstart = this.$listeners.loadstart;
      }
      return listeners;
    },
  },
  watch: {
    enabled(newStatus) {
      if (newStatus) {
        this.turnOn();
      }
    },
  },
  mounted() {
    this.bigImg = new Image();
    this.bigImg.src = this.bigSrc;
  },
  methods: {
    handMove(e) {
      if (!this.enabled) {
        return;
      }
      if (e.relatedTarget === this.$refs.mouseMask) {
        return;
      }
      const { imgLayer } = this.$refs;
      if (!imgLayer) {
        return;
      }
      let backgroundX;
      let backgroundY;
      const imgObj = this.$refs.imgObj || {};
      const imgRect = imgObj.getBoundingClientRect() || {};
      const objX = ((e.type === 'touchmove' || e.type === 'touchstart') ? e.changedTouches[0].clientX : e.clientX) - imgRect.left;
      const objY = ((e.type === 'touchmove' || e.type === 'touchstart') ? e.changedTouches[0].clientY : e.clientY) - imgRect.top;
      backgroundX = objX * (Math.ceil(this.bigImg.width / imgObj.offsetWidth) / 1.5);
      backgroundY = objY * (Math.ceil(this.bigImg.height / imgObj.offsetHeight) / 1.5);
      const { mouseMask } = this.$refs;
      if (mouseMask) {
        let maskX = objX - this.maskWidth / 2;
        let maskY = objY - this.maskHeight / 2;
        if (maskY <= 0) {
          maskY = 0;
        }
        if (maskY + this.maskHeight >= imgRect.height) {
          maskY = imgRect.height - this.maskHeight;
        }
        if (maskX <= 0) {
          maskX = 0;
        }
        if (maskX + this.maskWidth >= imgRect.width) {
          maskX = imgRect.width - this.maskWidth;
        }
        mouseMask.style.webkitTransform = `translate3d(${maskX}px,${maskY}px,0)`;
      }
      if (backgroundY + this.actualBigHeight >= this.bigImg.height) {
        backgroundY = this.bigImg.height - this.actualBigHeight;
      }
      if (backgroundX + this.actualBigWidth >= this.bigImg.width) {
        backgroundX = this.bigImg.width - this.actualBigWidth;
      }
      imgLayer.style.backgroundPositionX = `-${backgroundX}px `;
      imgLayer.style.backgroundPositionY = `-${backgroundY}px `;
    },
    handOut(e) {
      if (e.type === 'touchcancel') {
        this.turnOff();
        return;
      }
      if (e.type === 'touchend') {
        if (e.target !== this.$refs.imgObj) {
          return;
        }
      } else if (e.relatedTarget === this.$refs.mouseMask
          || (this.internal && e.relatedTarget === this.$refs.imgLayer)
      ) {
        return;
      }
      this.turnOff();
    },
    handOver(e) {
      if (!this.enabled) {
        return;
      }
      if (e.type === 'touchstart') {
        if (e.target !== this.$refs.imgObj) {
          return;
        }
      } else if (e.toElement !== this.$refs.imgObj) {
        return;
      }
      this.turnOn();
      this.$nextTick(function handMove() {
        this.handMove(e);
      });
    },
    turnOn() {
      this.isActive = true;
      this.$emit('zoom-turn-on');
      this.$nextTick(function turnOn() {
        const { imgLayer } = this.$refs;
        if (!imgLayer) {
          return;
        }
        const { mouseMask } = this.$refs;
        if (mouseMask) {
          mouseMask.style.height = `${this.maskWidth}px`;
          mouseMask.style.width = `${this.maskHeight}px`;
        }
        const imgObj = this.$refs.imgObj || {};
        const imgRect = imgObj.getBoundingClientRect() || {};
        this.actualBigHeight = (this.internal ? imgRect.height : this.bigHeight) || 0;
        this.actualBigWidth = (this.internal ? imgRect.width : this.bigWidth) || 0;
        imgLayer.style.width = `${this.actualBigWidth}px`;
        imgLayer.style.height = `${this.actualBigHeight}px`;
      });
    },
    turnOff() {
      this.isActive = false;
      this.$emit('zoom-turn-off');
    },
  },
};
